import type {InputField} from './InputField';

export type Platform = {
  code: string;
  title: string;
  enabled: boolean;
  hasCredentials: boolean;
  credentials: Array<InputField>;
  extraFields: Array<InputField>;
};
